<div class="container-fluid">
  <app-header titleText="Bid Log Report" i18n-titleText>
    <div button class="float-right">
      <div *ngIf="!isRequesting">
        <button type="button" class="btn btn-bidit-navigate mr-1" (click)="showParameters()" i18n>Update Filters</button>
        <button *ngIf="report" type="button" class="btn btn-bidit-navigate" (click)="renderReport()" i18n>Export</button>
      </div>
      <app-spinner [isRunning]="isRequesting"></app-spinner>
    </div>
  </app-header>

  <div *ngIf="report == null" class="container">
    <div class="row">
      <h5 class="col-sm-12" i18n>Please provide report criteria</h5>
    </div>
  </div>
  <div *ngIf="report">
        <div class="row header-text">

          <div class="col-md-4">
            <app-dealer-logo></app-dealer-logo>
          </div>
          <div class="col-md-6 filter-zone">
            <p>
              <span i18n>REPORT DEFINED:</span><br />
              <span i18n>Date Range:</span> {{parameters.startDate | date: 'M/d/yyyy'}} - {{parameters.endDate | date: 'M/d/yyyy'}}<br />
              <ng-template [ngIf]="salesperson"><span i18n>Salesperson:</span> {{salesperson.firstName}} {{salesperson.lastName}}<br /></ng-template>
              <ng-template [ngIf]="quoteStatus"><span i18n>Quote Status:</span> {{quoteStatus}}<br /></ng-template>
              <ng-template [ngIf]="jobType"><span i18n>Job Type:</span> {{jobType.jobType_Desc}}<br /></ng-template>
              <ng-template [ngIf]="customerType"><span i18n>Customer Type:</span> {{customerType.customerType_Desc}}<br /></ng-template>
              <ng-template [ngIf]="customer"><span i18n>Customer:</span> {{customer.customer_BusinessName}}<br /></ng-template>
            </p>
          </div>

        </div>

        <div class="content">
          <div class="quote-annual-summary">
            <h2 i18n>Annual Summary</h2>

            <div class="row">
              <div class="col col-sm-sept d-flex">

                <div class="card bid-log-card">
                  <div class="card-header" i18n># of Quotes</div>
                  <div class="card-body bid-log-card-body">
                    {{report.numberQuotes}}
                  </div>
                  <div class="card-footer"></div>
                </div>

              </div>
              <div class="col col-sm-sept d-flex">

                <div class="card bid-log-card">
                  <div class="card-header" i18n>Avg Quote $</div>
                  <div class="card-body bid-log-card-body">
                    ${{report.avgQuote | number: '1.2-2'}}
                  </div>
                  <div class="card-footer"></div>
                </div>

              </div>
              <div class="col col-sm-sept d-flex">

                <div class="card bid-log-card">
                  <div class="card-header" i18n>Total Quote $</div>
                  <div class="card-body bid-log-card-body">
                    ${{report.totalQuote | number: '1.2-2'}}
                  </div>
                  <div class="card-footer"></div>
                </div>

              </div>
              <div class="col col-sm-sept d-flex">

                <div class="card bid-log-card">
                  <div class="card-header" i18n>Margin $</div>
                  <div class="card-body bid-log-card-body">
                    ${{report.marginAmount | number: '1.2-2'}}
                  </div>
                  <div class="card-footer"></div>
                </div>

              </div>
              <div class="col col-sm-sept d-flex">

                <div class="card bid-log-card">
                  <div class="card-header" i18n># of Jobs</div>
                  <div class="card-body bid-log-card-body">
                    {{report.numberJobs}}
                  </div>
                  <div class="card-footer"></div>
                </div>

              </div>
              <div class="col col-sm-sept d-flex">

                <div class="card bid-log-card">
                  <div class="card-header" i18n>Avg Job $</div>
                  <div class="card-body bid-log-card-body">
                    ${{report.avgJob | number: '1.2-2'}}
                  </div>
                  <div class="card-footer"></div>
                </div>

              </div>
              <div class="col col-sm-sept d-flex">

                <div class="card bid-log-card">
                  <div class="card-header" i18n>$ Jobs</div>
                  <div class="card-body bid-log-card-body">
                    ${{report.totalJobs | number: '1.2-2'}}
                  </div>
                  <div class="card-footer"></div>
                </div>

              </div>
            </div>
            <div>
              <img [src]="bidLogSummary" alt="Bid log summary" *ngIf="!isSummaryLoading; else noReportSummary" class="bid-log-chart" />
              <ng-template #noReportSummary>
                <app-spinner [isRunning]="isSummaryLoading"></app-spinner>
              </ng-template>
            </div>
          </div>

          <div class="quote-month-summary">
            <h2 i18n>Detailed Month Summary</h2>
            <div>
              <table class="table table-bidit">
                <thead>
                  <tr>
                    <th i18n>Created</th>
                    <th i18n>Salesperson</th>
                    <th i18n>Customer</th>
                    <th i18n>Project Name</th>
                    <th i18n>Job $</th>
                    <th *ngIf="showMargins" style="width:100px;" i18n>Margin %</th>
                    <th *ngIf="showMargins" i18n>Margin $</th>
                    <th i18n>Job Type</th>
                    <th i18n>Status</th>
                    <th i18n>View</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-template ngFor let-aggregate [ngForOf]="report.aggregates">
                    <tr>
                      <td colspan="10">{{aggregate.category}}</td>
                    </tr>
                    <tr *ngFor="let quote of aggregate.details">
                      <td>{{quote.quote_Created | date: 'M/d/yyyy'}}</td>
                      <td>
                        <div>
                          <div *ngFor="let assignment of quote.quoteAssignments">
                            {{assignment.assignedTo.firstName}} {{assignment.assignedTo.lastName}}
                          </div>
                        </div>
                      </td>
                      <td>
                        <ng-template [ngIf]="quote.customer">
                          {{quote.customer.customer_BusinessName}}
                        </ng-template>
                      </td>
                      <td>{{quote.quote_Name}}</td>
                      <td>
                        <ng-template [ngIf]="quote.quote_BidAmount">
                          ${{quote.quote_BidAmount | number: '1.2-2'}}
                        </ng-template>
                      </td>
                      <td *ngIf="showMargins">
                        <ng-template [ngIf]="quote.quoteMargin">
                          {{quote.quote_GrossMargin | number: '1.0-4' }} %
                        </ng-template>
                      </td>
                      <td *ngIf="showMargins">
                        <ng-template [ngIf]="quote.quote_GrossMargin">
                          ${{quote.quote_BidAmount - quote.totalCost | number: '1.2-2'}}
                        </ng-template>
                      </td>
                      <td>
                        <ng-template [ngIf]="quote.jobType">{{quote.jobType.jobType_Desc}}</ng-template>
                      </td>
                      <td>{{quote.quoteStatus}}</td>
                      <td>
                        <a routerLink="/quote/{{quote.quote_ID}}" class="btn btn-bidit-submit" i18n>View</a>
                      </td>
                    </tr>
                    <tr class="log-summary-row">
                      <td colspan="2">
                        {{aggregate.category}} <span i18n>Totals</span>
                      </td>
                      <td></td>
                      <td></td>
                      <td>
                        <ng-template [ngIf]="aggregate.quote_BidAmount">
                          ${{aggregate.quote_BidAmount | number: '1.2-2'}}
                        </ng-template>
                      </td>
                      <td *ngIf="showMargins">
                        <ng-template [ngIf]="aggregate.totalCost">
                          {{aggregate.quoteMargin | number: '1.0-2' }} %
                        </ng-template>
                      </td>
                      <td *ngIf="showMargins">
                        <ng-template [ngIf]="aggregate.totalCost">
                          ${{aggregate.quote_BidAmount - aggregate.totalCost | number: '1.2-2'}}
                        </ng-template>
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  </ng-template>
                </tbody>
                <tfoot>
                  <tr class="log-summary-row">
                    <td colspan="2" i18n>Totals</td>
                    <td></td>
                    <td></td>
                    <td>
                      <ng-template [ngIf]="report.quote_BidAmount">
                        ${{report.quote_BidAmount | number: '1.2-2'}}
                      </ng-template>
                    </td>
                    <td *ngIf="showMargins">
                      <ng-template [ngIf]="report.totalQuote">
                        {{report.quoteMargin | number: '1.0-2'}} %
                      </ng-template>
                    </td>
                    <td *ngIf="showMargins">
                      <ng-template [ngIf]="report.totalQuote">
                        ${{report.quote_BidAmount - report.totalCost | number: '1.2-2'}}
                      </ng-template>
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
</div>
